import { Icons } from "assets";
import classNames from "classnames";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BarGraph from "shared/components/barGraph";
import { routeConstant } from "shared/routes/routesConstant";
import { totalEarningGraphs } from "shared/services/projectHeadService";
import styles from "./style.module.scss";
import { Skeleton } from "@mui/material";

function EarningGrid() {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [graphData, setGraphData] = useState<any>(null);
  const [loader, setLoader] = useState<boolean>(false);

  useEffect(() => {
    const today: any = new Date();
    const sevenDaysAgo: any = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);

    setStartDate(sevenDaysAgo?.toISOString().split("T")[0]);
    setEndDate(today?.toISOString().split("T")[0]);
  }, []);

  const navigate = useNavigate();

  const getStats = () => {
    setLoader(true);
    totalEarningGraphs({
      from: moment(startDate).format("YYYY-MM-DD"),
      to: moment(endDate).format("YYYY-MM-DD"),
    })
      .then(({ data: { data } }) => {
        setGraphData(data);
        setLoader(false);
      })
      .catch((err) => {
        console.log("Err", err);
        setLoader(false);
      });
  };

  useEffect(() => {
    if (startDate && endDate) {
      getStats();
    }
    //eslint-disable-next-line
  }, [startDate, endDate]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <label className={styles.heading}>
          Total Earning <label>(Last 7 Days)</label>
        </label>
        <label
          className={styles.viewDetail}
          onClick={() => navigate(routeConstant.earningDetail.path)}
        >
          View Details <Icons.ArrowPointLeft />
        </label>
      </div>
      <div className={styles.dataContainer}>
        <label className={styles.totalEarningHeading}>
          Rs{" "}
          {loader ? (
            <Skeleton variant="rectangular" width={100} height={20} />
          ) : (
            (
              Number(graphData?.total_plans) + Number(graphData?.total_topups)
            )?.toLocaleString()
          )}
        </label>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div className={styles.legendLabel}>
            <div className={classNames(styles.primaryDot, styles.dot)} />
            Plans
          </div>
          <div className={styles.legendLabel}>
            <div className={classNames(styles.secondaryDot, styles.dot)} />
            Top-up
          </div>
        </div>
      </div>
      <div className={styles.graphContainer}>
        {loader ? (
          <Skeleton variant="rectangular" width={"100%"} height={280} />
        ) : (
          <BarGraph earning_data={graphData} />
        )}
      </div>
      <div className={styles.earningCardContainer}>
        <div className={styles.earningCard}>
          <label className={styles.earningCardLabel}>Earning from Top-up</label>
          <label
            className={classNames(styles.earningCardStats, styles.secondary)}
          >
            Rs:
            {loader ? (
              <Skeleton variant="rectangular" width={100} height={20} />
            ) : (
              graphData?.total_plans?.toLocaleString()
            )}
          </label>
        </div>
        <div className={styles.earningCard}>
          <label className={styles.earningCardLabel}>Earning from Plan</label>
          <label
            className={classNames(styles.earningCardStats, styles.primary)}
          >
            Rs:
            {loader ? (
              <Skeleton variant="rectangular" width={100} height={20} />
            ) : (
              graphData?.total_topups?.toLocaleString()
            )}
          </label>
        </div>
      </div>
    </div>
  );
}

export default EarningGrid;
